import React, { Component } from 'react';
import styled from 'styled-components';
import T from 'aegisv2/Text';

import { baseMain, grayLight } from 'crehana-ui/styles/colors';
import ArrowBottom2 from 'crehana-icons/ArrowBottom2';
import ArrowTop from 'crehana-icons/ArrowTop';
import { func, string, bool } from 'prop-types';
// import category from '../propTypes/category';

import { FILTER_TYPES } from '../redux/reducer';
import FilterItem from './FilterItem';

/*
  TODO: improve animations
*/
const Container = styled.a`
  min-height: 48px;
  width: 100%;
  /* padding: 18px; */
  background-color: #fafafa;
  display: flex;
  flex-direction: column;
  padding: 12px 16px 13px 16px;
  & div {
    cursor: pointer;
  }
  @media (max-width: 1024px) {
    border-bottom: 1px solid ${grayLight};
    background-color: white;
    padding: 18px 16px 18px 16px;
  }
`;

const Header = styled.div`
  display: flex;
  flex-flow: row;
  align-items: center;
  justify-content: space-between;
`;

const FiltersContainer = styled.div`
  @media (max-width: 1024px) {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
`;

const MobileWrapper = styled.div`
  display: none;
  @media (max-width: 1024px) {
    display: block;
  }
`;

const DesktopWrapper = styled.div`
  display: block;
  @media (max-width: 1024px) {
    display: none;
  }
`;

class Filter extends Component {
  shouldComponentUpdate(nextProps) {
    const { open, subItemsSelected } = this.props;
    const nextSubItem = nextProps.subItemsSelected[0];
    const subItem = subItemsSelected[0];

    // const t0 = performance.now();
    const shoulUpdate =
      open !== nextProps.open ||
      // verify if software or levels filter has changed
      subItemsSelected.length !== nextProps.subItemsSelected.length ||
      // verify if categories filter has changed
      (!!subItem && subItem.itemId !== nextSubItem.itemId) ||
      (!!subItem &&
        !!subItem.itemId &&
        subItem.itemId === nextSubItem.itemId &&
        subItem.subItemId !== nextSubItem.subItemId);

    return shoulUpdate;
  }

  preventPropagation = e => {
    if (e.stopPropagation) e.stopPropagation();
  };

  toggleSubItem = ({ itemId, subItemId }) => e => {
    e.preventDefault();
    this.preventPropagation(e);
    this.props.toggleSubItem({ itemId, subItemId });
  };

  renderSubItems = () => {
    const {
      item: { subItems, id: itemId },
      subItemsSelected,
      itemType,
      filterName,
      countryPrefix,
    } = this.props;

    const subItemsArr = Object.keys(subItems);

    return subItemsArr.map(key => {
      let isSelected = false;
      const { id: subItemId, name, disabled, url } = subItems[key];

      if (itemType === FILTER_TYPES.CATEGORIES) {
        isSelected = Boolean(
          subItemsSelected.find(
            filter =>
              filter.subItemId === subItemId && itemId === filter.itemId,
          ),
        );
      }

      if (
        itemType === FILTER_TYPES.SOFTWARES ||
        itemType === FILTER_TYPES.LEVELS ||
        itemType === FILTER_TYPES.LANGUAGES
      ) {
        isSelected = Boolean(subItemsSelected.includes(subItemId));
      }

      return (
        <FilterItem
          key={subItemId}
          isSelected={isSelected}
          onClick={this.toggleSubItem({ itemId, subItemId })}
          disabled={disabled}
          name={name}
          countryPrefix={countryPrefix}
          url={url}
          filterName={filterName}
        />
      );
    });
  };

  openFilter = ({ itemId }) => e => {
    e.preventDefault();
    this.props.openFilter({ itemId });
  };

  render() {
    const {
      item: { id, name, subItems, url },
      open,
      countryPrefix,
    } = this.props;

    return (
      <Container
        length={Object.keys(subItems).length}
        onClick={this.openFilter({ itemId: id })}
        href={url ? (countryPrefix ? `/${countryPrefix}${url}` : url) : ''}
      >
        <Header>
          <div>
            <MobileWrapper>
              <T size={16}>{name}</T>
            </MobileWrapper>
            <DesktopWrapper>
              <T xs bold>
                {name}
              </T>
            </DesktopWrapper>
          </div>

          <DesktopWrapper>
            <div
              ref={el => {
                this.icon = el;
              }}
            >
              {open ? (
                <ArrowTop color={baseMain} size={7} />
              ) : (
                <ArrowBottom2 color={baseMain} size={7} />
              )}
            </div>
          </DesktopWrapper>
        </Header>
        <FiltersContainer
          ref={el => {
            this.inner = el;
          }}
          onClick={this.preventPropagation}
          style={{
            overflow: open ? 'auto' : 'hidden',
            maxHeight: open ? '280px' : 0,
          }}
        >
          <DesktopWrapper>{this.renderSubItems()}</DesktopWrapper>
        </FiltersContainer>
      </Container>
    );
  }
}

Filter.defaultProps = {
  filterName: undefined,
};

Filter.propTypes = {
  itemType: string.isRequired,
  open: bool.isRequired,
  toggleSubItem: func.isRequired,
  filterName: string,
};

export default Filter;
